module.exports = __webpack_public_path__ + "static/media/omologies_pisteos_gr.983633f0.png";